import React from 'react';
import Button from 'Components/common/Button';

const CancelSaveButton = props => {
  const { handleSave, handleCancel, saveButtonText = 'Save' } = props;
  return (
    <div className="button-group-wrapper">
      <Button
        id="cancel"
        name="cancel"
        type="button"
        btnText="Cancel"
        loader={false}
        click={() => handleCancel()}
      />
      <Button
        id="save"
        name="save"
        type="button"
        btnText={saveButtonText}
        loader={false}
        click={() => handleSave()}
      />
    </div>
  );
};

export default CancelSaveButton;
